import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import ErrorPage from 'app/ErrorPage';
import RootLayout from 'app/RootLayout';
import { getPageTitle } from 'app/pageTitles';

import Loading from 'shared/ui/Loading';

import DocStats from 'features/stats/pages/DocStats';
import { appRoutes } from 'features/app/routes';
import { companyRoutes } from 'features/company/routes';
import { consultantsRoutes } from 'features/consultants/routes';
import { crmRoutes } from 'features/crm/routes';
import { devRoutes } from 'features/dev/routes';
import { docsRoutes } from 'features/docs/routes';
import { partiesRoutes } from 'features/parties/routes';
import { posRoutes } from 'features/pos/routes';
import { productsRoutes } from 'features/products/routes';
import { statsRoutes } from 'features/stats/routes';

function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <TitleUpdater />
      <Routes>
        <Route path='/' element={<RootLayout />} errorElement={<ErrorPage />}>
          <Route index path='dashboard' element={<Suspense fallback={<Loading />}><DocStats /></Suspense>} />

          {statsRoutes}
          {companyRoutes}
          {devRoutes}
          {consultantsRoutes}
          {docsRoutes}
          {productsRoutes}
          {partiesRoutes}
          {crmRoutes}
          {appRoutes}
          {posRoutes}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
